<template>
    <mdb-container>
        <mdb-card cascade class="cascading-admin-card">
            <!--Card Data-->
            <div class="admin-up">
                <mdb-icon icon="chart-line" class="warning-color"></mdb-icon>
                <div class="data">
                    <p>UTILISATEURS</p>
                    <mdb-spinner small color="blue" v-if="nb===0" />
                    <h4 class="font-weight-bold dark-grey-text" v-else>{{nb}}</h4>
                </div>
            </div>
            <!--/.Card Data-->

            <!--Card content-->
            <mdb-card-body cascade>
                <mdb-btn color="primary" size="sm" v-if="nb>0" v-on:click="gotoshowpreregistrations">Voir les utilisateurs</mdb-btn>
            </mdb-card-body>
            <!--/.Card content-->
        </mdb-card>
    </mdb-container>
</template>

<script>
    import {
        mdbCard,
        mdbIcon,
        mdbCardBody,
        mdbBtn,
        mdbContainer,
        mdbSpinner,
    } from 'mdbvue';
    import Apicall from '../libs/Apicall';

    export default {
        name: 'nbinscriptioncard',
        components: {
            mdbCard,
            mdbIcon,
            mdbCardBody,
            mdbBtn,
            mdbContainer,
            mdbSpinner,
        },
        data() {
            return {
                nb: 0,
            };
        },
        mounted() {
            this.getAndDisplayFormations();
        },
        methods: {
            getAndDisplayFormations() {
                const api = new Apicall();
                const self = this;
                api.getNbInscriptions().then((response) => {
                    if (response.status === 'OK') {
                        self.nb = response.nb;
                    }
                });
            },

            gotoshowpreregistrations() {
                this.$router.push({ path: 'adminuser' });
            },
        },
    };
</script>

<style scoped>
    .cascading-admin-card {
        margin-top: 20px; }
    .cascading-admin-card .admin-up {
        margin-left: 4%;
        margin-right: 4%;
        margin-top: -20px; }
    .cascading-admin-card .admin-up .fas, .cascading-admin-card .admin-up .far, .cascading-admin-card .admin-up .fab {
        padding: 1.7rem;
        font-size: 2rem;
        color: #fff;
        text-align: left;
        -webkit-border-radius: 3px;
        border-radius: 3px; }
    .cascading-admin-card .admin-up .data {
        float: right;
        margin-top: 2rem;
        text-align: right; }
    .cascading-admin-card .admin-up .data p {
        color: #999999;
        font-size: 12px;
    }
</style>
